import { Article } from "./Article";

export class Result {
  listOfArticles!: Article[];
}

export class AskResult extends Result {
  answer!: string;
  listOfArticleIds: number[] = [];

  constructor() {
    super();
    this.listOfArticles = [];
  }
}
